<template>
  <div>
    <ask
      ref="askNotificationsReminder"
      title="Payment Request Reminders"
      @ok="remind"
      :message="
        'Are you sure you would like to resend the selected payment requests?'
      "
    ></ask>

    <ask
      ref="askRemoveNotifications"
      title="Cancel Payment Requests"
      @ok="remove"
      :message="
        'Are you sure you would like to cancel the selected payment request?'
      "
    ></ask>

    <b-card-header class="border-0">
      <b-row>
        <b-col class="col-sm-10">
          <h3 class="mb-0">Payment Requests</h3>
        </b-col>
        <b-col style="text-align: right"> </b-col>
      </b-row>
    </b-card-header>

    <el-table
      id="notificationsTable"
      class="table-responsive table-flush hover"
      header-row-class-name="thead-light"
      :data="notifications"
      type="selection"
      hover
      @row-click="notificationSelected"
      @sort-change="sortChange"
    >
      <el-table-column
        label="Date"
        prop="created"
        min-width="125px"
        sortable="custom"
      >
        <template v-slot="{ row }">
          {{ row.created | moment("MM/DD/YYYY") }}<br />
          <small>{{ row.created | moment("hh:mm:ss A") }}</small>
        </template>
      </el-table-column>

      <el-table-column
        label="Patient"
        min-width="100px"
        sortable="custom"
        prop="lastName"
        v-if="!supressPatientName"
      >
        <template v-slot="{ row }">
          {{ row.firstName }} {{ row.lastName }}
        </template>
      </el-table-column>

      <el-table-column label="Phone" prop="created" min-width="125px">
        <template v-slot="{ row }">
          {{ row.toPhone | phonenumber }}
        </template>
      </el-table-column>

      <el-table-column label="Email" prop="created" min-width="175px">
        <template v-slot="{ row }">
          {{ row.eMail }}
        </template>
      </el-table-column>

      <el-table-column label="Paid" prop="created" min-width="125px">
        <template v-slot="{ row }">
          {{ row.paid | moment("MM/DD/YYYY") }}<br />
        </template>
      </el-table-column>

      <el-table-column
        label="Amount "
        prop="amount"
        sortable="custom"
        min-width="125px"
      >
        <template v-slot="{ row }">
          {{ (row.amount / 100) | currency }}
        </template>
      </el-table-column>

      <el-table-column @click.stop label="" min-width="50px">
        <template v-slot="{ row }">
          <input
            @click.stop
            type="checkbox"
            v-model="row.selected"
            v-show="!row.paid"
          />
        </template>
      </el-table-column>
    </el-table>

    <div class="float-right">
      <b-dropdown
        right
        v-show="rows > 0 && hasOneForPayment()"
        class="p-3"
        variant="primary"
        text="Action"
      >
        <b-dropdown-item @click="$refs.askNotificationsReminder.ask()"
          ><i class="fa-solid fa-bell-on"></i>Send Reminder</b-dropdown-item
        >
        <b-dropdown-item @click="$refs.askRemoveNotifications.ask()"
          ><i class="fa-solid fa-trash-can-xmark ml-1"></i> Cancel Request</b-dropdown-item
        >
      </b-dropdown>
    </div>
    <b-pagination
      v-if="showPagination"
      align="center"
      class="mt-3"
      v-model="page"
      :total-rows="rows"
      :per-page="perPage"
      @change="pageChange"
    ></b-pagination>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  name: "notification-search-results",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  props: {
    query: {},
    supressPatientName: false,
  },
  watch: {
    query: {
      immediate: true,
      async handler(newVal) {
        this.bind(1);
      },
      deep: true,
    },
  },

  data() {
    return {
      rows: null,
      notificationsSelected: [],
      perPage: 10,
      sort: null,
      notifications: [],
      page: 1,
      showPagination: false,
    };
  },
  mounted() {
    this.$emitter.once("bind-notifications", (e) => {
      this.bind(this.page);
    });
  },
  methods: {
    notificationSelected(item) {
      this.$emitter.emit("show-notification", item.id);
    },

    hasOneForPayment() {
      var self = this;

      var foundOne = self.notifications.find((e) => {
        return !e.paid == true;
      });
      return foundOne;
    },
    getSelectedItems() {
      var self = this;
      return self.notifications.flatMap((e) => {
        if (e.selected) return e.id;
        else return [];
      });
    },
    remind() {
      var self = this;

      self.$client
        .post("/api/notification/remind", { ids: self.getSelectedItems() })
        .then((r) => {
          if (r.data.isSuccess) {
            self.$emitter.emit("success", { message: "Reminders Sent" });
          }
        });
    },
    remove() {
      var self = this;

      self.$client
        .post("/api/notification/remove", { ids: self.getSelectedItems() })
        .then((r) => {
          if (r.data.isSuccess) {
            self.bind(1);
            self.$emitter.emit("success", { message: "Notifications Removed" });
          }
        });
    },
    sortChange(a) {
      var self = this;
      self.page = 1;

      if (a.prop && a.order) self.sort = a.prop + ":" + a.order;
      else self.sort = null;

      this.bind(1);
    },
    pageChange(pg) {
      this.bind(pg);
    },

    bind(page) {
      var self = this;

      var form = this.query;

      self.page = page;
      form.sort = self.sort;
      form.page = page;

      self.$client
        .post("/api/notification/getNotifications", form)
        .then((response) => {
          if (response.data.isSuccess) {
            var notifications = [];
            response.data.value.forEach((e) => {
              e.selected = e.paid == null;
              notifications.push(e);
            });

            self.notifications = notifications;

            self.rows = response.data.value[0].rows;
            self.showPagination = self.rows > 10;
          }
        });
    },
  },
};
</script>
<style>
body #notificationsTable tr:hover {
  background-color: #f6f9fc;
  cursor: pointer;
}
</style>
